import React from "react";
import SimpleCRUD from "../../components/SimpleCRUD";

export default function Jabatan() {
  return (
    <SimpleCRUD
      title="Management Jabatan"
      endpoint="/jabatan"
      testidPrefix="jabatan"
      fields={[
        { key: "nama", label: "Nama Jabatan", required: true },
        { key: "divisi_id", label: "Divisi", refEndpoint: "/divisi", refLabel: "nama" },
        { key: "level", label: "Level Jabatan" },
        { key: "keterangan", label: "Keterangan", type: "textarea" },
      ]}
    />
  );
}
